import UnicornApp from '../app';
import UnicornLoader from './loader';
export default class UnicornAlpine2 {
    app;
    static install(app) {
        // Disable Alpine auto load for Apline v2.
        window.deferLoadingAlpine = () => { };
        const self = app.$alpine2 = new this(app);
    }
    constructor(app) {
        this.app = app;
        //
    }
    import(...args) {
        return this.app.inject('$loader').import(...args);
    }
    ie11() {
        return this.import('@vendor/alpinejs/dist/alpine-ie11.js');
    }
    loadAlpine() {
        return this.import('@alpinejs');
    }
    loadSpruce() {
        return Promise.all([
            this.loadAlpine(),
            this.import('@spruce')
        ]);
    }
    async initAlpine(selector) {
        await this.loadAlpine();
        const element = this.app.selectOne(selector);
        // @ts-ignore
        Alpine.initializeComponent(element);
    }
    async startAlpine() {
        await this.loadAlpine();
        if (Spruce) {
            Spruce.start();
        }
        // @ts-ignore
        Alpine.start();
    }
    async startAlpineSpruce() {
        await this.loadSpruce();
        // @ts-ignore
        Alpine.start();
    }
    async initAlpineSpruce(selector) {
        await this.loadSpruce();
        const element = this.app.selectOne(selector);
        // @ts-ignore
        Alpine.initializeComponent(element);
    }
}
